let $ = jQuery;

// import Jump
import Jump from 'jump.js'

class LabPublications {

  constructor() {
    this.$publicationsWrapper = $('.js-lab-publications');
    this.$pagination;
    this.scrollSpeed = 250;
    this.$publicationJumpLinks;
    this.$backToTops;

    if (this.$publicationsWrapper.length) {
      this.init();
    }
  }

  init() {
    this.jump = new Jump();
    this.$pagination = this.$publicationsWrapper.find('.lab-publications__pagination');
    this.$publicationJumpLinks = this.$publicationsWrapper.find('.js-publications-jump-link');
    this.$backToTops = this.$publicationsWrapper.find('.js-back-to-top');

    // Bind Events.
    this.$publicationJumpLinks.off('click.pubJump').on('click.pubJump', (e) => this.jumpToYear(e));
    this.$backToTops.off('click.pubJump').on('click.pubJump', (e) => this.backToTop(e));
  }

  jumpToYear(e) {
    let $target = $(e.currentTarget);
    let year = $target.attr('href').replace(/^#/, '');
    let $elem = $('.lab-publications__section--' + year);
    let offset = this.getOffset($elem);

    this.jump.jump(offset, {
      duration: this.scrollSpeed
    });

    return false;
  }

  backToTop(e) {
    let $target = $(e.currentTarget);

    let offset = this.getOffset(this.$pagination);

    this.jump.jump(offset, {
      duration: this.scrollSpeed
    });

    return false;
  }

  getOffset($elem) {
    let offset;
    let currOffset = $(document).scrollTop();
    let targetOffset = $elem.offset().top;
    let $adminBar = $('#toolbar-item-administration-tray');
    let $nav = $('.js-main-nav-wrapper');
    let topItemsHeight = $nav.outerHeight();

    if ($adminBar.length) {
      topItemsHeight += $adminBar.outerHeight();
    }

    offset = (targetOffset - currOffset) - topItemsHeight;

    return offset;
  }
}

module.exports = {
  attach: function(context, settings) {
    let labPublications = new LabPublications();
  }
}
